import { ControlLevel } from '@/business-logic/profile'

export const getControlLevelText = (controlLevel: ControlLevel) => {
  switch (controlLevel) {
    case ControlLevel.Full: {
      return 'app.authorized_apps.full_control'
    }
    case ControlLevel.Partial: {
      return 'app.authorized_apps.partial_control'
    }
    case ControlLevel.None: {
      return 'app.authorized_apps.no_control'
    }
  }
}
